/**
 * Private modules
 */
const {
  createQueryComponent,
  systemId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  DEFAULT,
  SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID,
  SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID,
} = require('../../scopes');

/**
 * Constant variables
 */
const rootId = { oneOf: [{ pattern: '^\\d+$', type: 'string' }, { type: 'number' }] };
module.exports = {
  getSystemGameTypesByRootId: {
    properties: {
      params: {
        properties: {
          rootId,
          systemId,
        },
        required: [
          'rootId',
          'systemId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        DEFAULT,
        SYSTEM_GAME_TYPES_DEACTIVATED_BY_ROOT_ID,
        SYSTEM_GAME_TYPES_INPUT_BY_ROOT_ID,
      ]),
    },
    required: ['params'],
    type: 'object',
  },
};
